import { ComponentChildren } from "preact";
import { LineIcon } from "./PotsComponents.tsx";

export function BenefitCard(
  props: { icon: string; title: string; description: string },
) {
  const isImagePath = !props.icon || props.icon.startsWith("/");
  return (
    <div class="benefit-card">
      {isImagePath
        ? <img src={props.icon || "/img/icons/1starforwebsite.svg"} alt={props.title} class="benefit-icon" />
        : <LineIcon name={props.icon} />}
      <h3 class="benefit-title">{props.title}</h3>
      <p class="benefit-description">{props.description}</p>
    </div>
  );
}

export function Benefits(props: { children: ComponentChildren }) {
  return <div className="benefits">{props.children}</div>;
}
